import { createFileRoute } from '@tanstack/react-router';

import { LoadingPage } from '@nesso/ui/blocks/loading-page';

import { ProfilePage, profileSearchSchema } from '@/pages/settings/profile';

export const Route = createFileRoute('/settings/profile')({
    component: ProfilePage,
    validateSearch: profileSearchSchema,
    pendingComponent: LoadingPage,
});
